import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const getToken = () => localStorage.getItem("token");

export const getPayments = async ({ offset = 1, limit = 10, search = "", status = "" }) => {
    return axios.get(`${API_BASE_URL}/admin/payments`, {
        params: { offset, limit, status, search },
        headers: { token: getToken() },
    });
};

export const getPartnerPayments = async ({ offset = 1, limit = 10, search = "", status = "" }) => {
    return axios.get(`${API_BASE_URL}/admin/partner-payments`, {
        params: { offset, limit, status, search },
        headers: { token: getToken() },
    });
};